let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kHvWr")).then(() => parcelRequire('gau1G'));